import { useEffect, useRef } from "react";

export const useTimeLimitRecorder = ({
    timer = 0,
    mediaUrl = "",
    mediaBlob = null,
    onConfirmSubmit = () => {}
}) => {
    const firstRender = useRef(false);
    const timerTimeoutRef = useRef(null);
    const mediaBlobRef = useRef(null);
    const mediaUrlRef = useRef(null);

    const cleanTimeout = () => {
        if(timerTimeoutRef.current){
            clearTimeout(timerTimeoutRef.current);
        }
    }

    useEffect(() => {
        mediaUrlRef.current = mediaUrl;
        mediaBlobRef.current = mediaBlob;
    }, [mediaUrl, mediaBlob])

    useEffect(() => {       
        if(timer > 0 && !timerTimeoutRef.current) {
          timerTimeoutRef.current = setTimeout(() => {
            onConfirmSubmit();
          }, timer * 1000);
        }
        return () => {
        //  FIXME: if component re-renders multiple times, the `cleanTimeout` function is called multiple times
        //   if(firstRender.current) {            
        //     cleanTimeout();
        //   }
          firstRender.current = true;
        }
    }, [timer, onConfirmSubmit]);

    return {
        mediaBlobRef,
        mediaUrlRef,
        cleanTimeout,
    }
}